import Vue from 'vue';
import { Component, Prop, Provide, Watch } from 'vue-property-decorator';
import StageHeader from '../../components/stageHeader';
import UinsDefaultSelect from '../../components/unisDefaultSelect';
import template from './tracking.vue';
import MainButtonSet from '../../components/mainButtonSet';
import UnisProductModal from '../../components/unisProductModal';
import Datepicker from 'vuejs-datepicker';
@Component({
    mixins: [template],
    components: {
        Datepicker,
        StageHeader,
        MainButtonSet,
        UinsDefaultSelect,
        UnisProductModal,
    },
})
export default class Tracking extends Vue {
    trackShipment: any = {};
    truckloadForm: any = {};
    editProductModal: string = 'addNewPaymentMethod';
    showTageName: string = 'Shipment activity';
    foldBody: number = 0;
    invoiceId: String = '';
    invoiceInfo: any = {};
    showErrTip: boolean = false;
    errorText: String = '';

    created() {}

    clickFold(tagName: string) {
        this.showTageName = tagName;
    }

    mounted() {}
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/layouts/tracking/index.ts